module.exports = undefined;


//////////////////
// WEBPACK FOOTER
// external {"amd":"backbone","root":"Backbone"}
// module id = 37
// module chunks = 0